const parseEuropeanNumber = (value) => {
  if (value === null || value === undefined || value === '') {
    return null
  }
  
  if (typeof value === 'number') return value
  
  const stringValue = String(value).trim()
  const normalized = stringValue.replace(',', '.')
  
  const parsed = parseFloat(normalized)
  
  return isNaN(parsed) ? null : parsed
}

export default parseEuropeanNumber